var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs, _g, _polygon, _path46, _path47, _circle, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg500(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 416 390",
    style: {
      enableBackground: "new 0 0 416 390"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:#E1E8F6;}\n\t.st2{fill:#E6E8E8;}\n\t.st3{opacity:0.75;fill:none;stroke:#FFFFFF;stroke-miterlimit:10;enable-background:new    ;}\n\t.st4{fill:#EE5050;}\n\t.st5{fill:#D35050;}\n\t.st6{fill:url(#SVGID_1_);}\n\t.st7{fill:#19034D;}\n\t.st8{fill:#FF735F;}\n\t.st9{fill:#F8BD7A;}\n\t.st10{fill:#DB6352;}\n\t.st11{fill:none;stroke:#19034D;stroke-miterlimit:10;}\n\t.st12{fill:url(#SVGID_2_);}\n\t.st13{fill:url(#SVGID_3_);}\n\t.st14{fill:url(#SVGID_4_);}\n\t.st15{fill:url(#SVGID_5_);}\n\t.st16{fill:#262B40;}\n\t.st17{fill:#FFFFFF;}\n\t.st18{fill:#0648B3;}\n\t.st19{clip-path:url(#SVGID_7_);}\n\t.st20{fill:#228F4E;}\n\t.st21{fill:#F5BA00;}\n\t.st22{fill:none;stroke:#0648B3;stroke-width:2;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#E1E8F6;stroke-width:2;stroke-miterlimit:10;}\n\t.st24{font-family:'OpenSans-Bold';}\n\t.st25{font-size:60px;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "OBJEKTS"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.7,170.6h75c12.7,0,23,10.3,23,23v30.9l0,0h-98c-12.7,0-23-10.3-23-23l0,0v-7.9 C52.7,180.9,63,170.6,75.7,170.6L75.7,170.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.1,364.7c27.6-9.7,54.2-26.3,71.7-50.6c21.4-29.6,19.5-63.2,23.9-97.9c1.8-14.1,11.2-22.2,16.8-34.6 c11.8-26.3,7.6-65.9-17.2-83.8c-15.3-11-30.1-12.2-38.4-31.4c-4.6-10.6-7.2-22.2-14.3-31.3c-10.2-13.2-27.7-18.4-44.1-21 c-19.2-3-37.9-2.3-57.1-2.9c-20.5-0.6-41.3,0-61.2,5.4c-27,7.4-56.7,26.7-61.4,56.2c-2,12.6,0.6,26.1-4.2,37.9 c-7.2,17.8-26.4,23.9-40.8,34.4c-15.4,11.3-25.4,29-29.8,47.3c-7.5,31.3-2,66,12.6,94.4c15.6,30.4,40.9,56.3,71.5,71.5 c24,11.9,57.2,15.4,84.3,17.1C218,377.3,248.2,374.5,276.1,364.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M346.6,242.6c-0.2-44.7-12.5-87.6-48.9-116.4c-44.9-35.5-107.6-35.1-153.4-1.9c-30,21.7-51,54.3-62.8,89.4 s-14.8,72.6-13.6,109.6l273,0.9l3.4-37.6C345.6,272,346.6,257.3,346.6,242.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.7,165.6h75c12.7,0,23,10.3,23,23v30.9l0,0h-98c-12.7,0-23-10.3-23-23v-7.9C67.7,175.9,78,165.6,90.7,165.6 L90.7,165.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M152.5,59.4h104.7c16.8,0,30.5,13.6,30.5,30.4l0,0v40.8l0,0H152.5c-16.8,0-30.5-13.6-30.5-30.4l0,0V89.8 C122,73,135.6,59.4,152.5,59.4L152.5,59.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.4,316.1c-0.4-0.3-0.8-0.6-1.2-0.9c-1.4-1.1-1.7-3.1-1.9-4.9c-1.8-22,1.5-44.1,0.4-66.2 c-0.2-5.3-4.5-2.7-8-2c-0.5,0.1-7.3,1.4-7.3,0.6c-0.6,6.3-1.4,13-5.6,17.7c-2.9,3.3-7,5.1-10.6,7.6c-13.6,9.2-21.5,26.9-23.4,42.9 c0-0.4-0.1-0.7-0.1-1.1c-0.3-3.2-0.5-6.4-0.6-9.6c-0.3-6.7-0.4-13.4-0.3-20.1c0.1-5,0.7-10.5-2.3-14.8c-2.6-3.7-5.4-4-9-4.3 c-1-2-0.8-5.9-0.8-7.7c0-2.9,0.5-6.1,2.6-8.3c3.4-3.6,8.7-1.4,13.1-2.5c9.8-2.5,6.3-15,5.7-22.2c-0.4-4.4-7.4-4.5-7,0 c0.3,3.6,1,7.4,1,11c0,2.3,0,3.8-2.4,4.6c-1.1,0.1-2.3,0.1-3.4,0c-5.1,0-9.5,1.1-12.8,5.2c-3.6,4.5-4.2,10.3-3.6,15.8 c0.4,4.2,0.6,10,5.7,10.9c4.7,0.8,6.2,1.8,6.3,6.8c0.1,3.4-0.2,6.8-0.2,10.2c0,7.7,0.2,15.3,0.8,23c0.3,4.4-0.4,12.3,3.3,15.6 c1.6,1.5,3.9,1.8,5.9,0.8c5.8,0.3,19.6-0.5,21.1-0.5h17.8c3,0,8.2,1,11.1-0.5c1.5-0.8,4.3-2.2,5.4-3.5 C115.2,318.8,115.2,317.2,114.4,316.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112,250.5c0-1.8,0-3.6-0.1-5.4c0-0.4,0-0.7-0.1-1c-0.1-0.4-0.2-0.7-0.3-1.1c-1.3-2.5-5.9-0.3-7.7,0.5 c-2,1-3.9,2.2-5.6,3.6c-1.1,0.7-2.1,1.7-2.7,2.9c-0.6,1.3-0.2,3.3-0.1,4.7c0,1,0.3,2.1,0.9,2.9c0.6,0.9,1.8,1.2,2.7,0.7 c0.1,1.1,0.4,2.2,0.9,3.2c0.4,0.8,1.2,1.3,2,1.5c0.6,0.2,0.5,0.1,0.7,0.6l0,0c0.1,0.5,0.3,0.9,0.5,1.3v0.1c0.1,0.3,0.3,0.6,0.6,0.8 c0.1,0.1,0.3,0.2,0.5,0.3l0,0c0.3,0.2,0.7,0.3,1.1,0.4c1,0.2,2-0.3,2.6-1.1c0.5-1,0.6-2.1,0.4-3.2c0.8,0,1.5-0.5,1.8-1.3 c0.3-0.9,0.4-1.9,0.3-2.8c0-1.1,0-2.1-0.1-3.2C112.4,255.2,112,252,112,250.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.352,
    y1: -114.5988,
    x2: 68.882,
    y2: -99.7087,
    gradientTransform: "matrix(1 0 0 -1 42 196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE5050",
      stopOpacity: 0.91
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#311573",
      stopOpacity: 0
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M88.9,286.3c3.6,2.2,5.7,6.3,5.4,10.6c-0.4,4.3-3.9,7.8-7,10.4s-7,5.3-9.1,9.1c2.2-0.3,4.4-0.4,6.6-0.5 c1.9-0.1,4,0.1,5.1,1.6s0.5,3.8,0.8,5.7c0.2,0.1,0.5,0.1,0.7-0.1c0.2,0.5,0.1,0.5,0.6,0.5c1.8-0.3,3.3-1.4,4.1-3 c0.7-1.6,1.1-3.3,1.3-5.1c0.8-6.2,1-12.5,0.7-18.8c0-2-0.4-4-1.3-5.8C95,288.2,92.2,286.1,88.9,286.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.2,228.2c-0.1-0.3-0.2-0.6-0.3-0.9c0,0.2,0.8,0.5,1,0.5l1.1,0.6c0.7,0.4,1.4,0.8,2.1,1.2s1.4,0.8,2.1,1.3 c0.3,0.2,0.5,0.4,0.8,0.3c0.5-0.1,1-0.3,1.5-0.6l1.8-0.7l3.6-1.4c2.4-0.9,4.8-1.9,7.1-2.9c0.9-0.4,3-0.9,3.3-1.9 c0.1-0.4,0.2-0.7,0.1-1.1c0.1-1.9,0.5-5.5,0.5-5.5s1.4,1.2,1.6,1.5c0.5,0.6,1,1.2,1.5,1.9c1,1.3,1.8,2.6,2.6,4 c1.7,3,3.1,6.1,4.2,9.3c0.9,2.6,1.4,5.2-0.3,7.5c-1.6,2.2-4.2,3.5-6.5,4.8c-4.8,2.5-9.9,5.2-15.3,5.7c-1.4,0.2-2.7,0-4-0.5 c-1.2-0.7-2.2-1.7-2.8-3C82.7,241.9,82,234.9,80.2,228.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.9,242c-1.6-0.5-3.2-0.6-4.8-1.1c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.5-0.8,0.7-1.3 c0.1-0.2,0.1-0.6-0.2-0.7h-0.1c-0.5-0.2-1.4,0.3-1.9,0.5c-0.8,0.3-1.5,0.6-2.2,1c-0.2,0.1-0.3,0.4-0.2,0.7c0.1,0.1,0.2,0.2,0.3,0.2 l2,0.6c-0.7,1.7-1.3,3.4-1.7,5.2c-0.1,0.3,0.1,0.6,0.4,0.6c0.3,0.1,0.6-0.1,0.6-0.4c0.5-1.7,1-3.4,1.7-5c1.6,0.5,3.3,0.6,4.9,1.1 C107.2,243.2,107.5,242.2,106.9,242z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M93.1,237.8c-0.2-0.1-0.4-0.1-0.6,0c-0.1,0-0.3,0-0.4,0.2c-0.1,0.1-0.2,0.3-0.2,0.4s-0.1,0.2-0.1,0.2 c0,0.1,0,0.3,0.1,0.4c0.2,0.5,0.7,0.7,1.2,0.5c0.2-0.1,0.4-0.2,0.5-0.4c0.3-0.4,0.1-1-0.3-1.3C93.3,237.9,93.2,237.8,93.1,237.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M108.1,231.8c-0.2-0.1-0.4-0.1-0.6,0c-0.1,0-0.3,0-0.4,0.2c-0.1,0.1-0.2,0.3-0.2,0.4s-0.1,0.2-0.1,0.2 c0,0.1,0,0.3,0.1,0.4c0.2,0.5,0.7,0.7,1.2,0.5c0.2-0.1,0.4-0.2,0.5-0.4c0.3-0.4,0.1-1-0.3-1.3C108.3,231.9,108.2,231.8,108.1,231.8 z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M134,296.7c-1.9,6.5-3.5,14.1,0.3,19.7c4.6,6.8,15.3,6.7,22,2s10.3-12.6,13.4-20.2 c5.2-12.8,9.8-25.9,11.6-39.6c1.1-8,0.1-17.9-7.1-21.4c-11.2-5.4-20.7,3.2-24.3,12.6C144,265.2,138.7,280.8,134,296.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.9,214.2c-2.9,3.1-5.4,6.4-7.7,9.9c-3.1,4.9-5.3,10.1-7.7,15.4c-0.9,1.8-8.1,17.8-6.5,18.9 c9.1,6.5,18.1,13.7,28.6,17.7c0.4,0.1-1.6,7.8-1.8,8.5c-0.7,2.8-1.4,5.7-1.9,8.5c-1.1,5.7-2.1,11.5-3.1,17.2 c-0.6,3.2-1.1,6.4-1.6,9.6c-0.2,1.4,45.2,4.5,49.3,4.5c12,0.2,30.9,3.5,38.2-8.7c1.6-3,2.7-6.2,3.4-9.5c4.5-19.3,6.5-39.2,6-59 c0-4.7-0.5-9.3-1.5-13.9c-1.6-6.6-5.1-12.5-8.7-18.1c-3.3-5.2-8.5-8-14-10.7c-16.5-7.9-36.5-10.5-53.2-3.1 C178.9,204.5,172.9,208.9,167.9,214.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M243.5,261c-0.5,1-0.9,2.1-1.4,3.1c-1.8,4-6.1,11-6.1,15.4c-2.1,6.4-3,13.3-1.8,19.9c0.5,2.6,1.3,5.2,2.2,7.8 c1,3.3,2.4,6.4,4.3,9.2c1.8,2.4,6.2,6.3,9.6,5s6.2-7.8,7.5-11c8-18.8,11.2-39.5,13.1-59.8c0.7-3.6-0.5-7.3-3.1-9.7 c-1.8-2.2-3.8-4.5-6.5-5c-2.8-0.5-5.4,0.9-7.2,2.9c-1.7,2.1-3.1,4.5-4,7L243.5,261z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M258,258.9c-1.5-0.4-23.1-5.7-23.1-3c0.2-11.7,0.8-23.4,1.9-35.1c0.2-3.7,0.9-7.4,2.2-10.9 c1.4-3.4,4-6.6,7.4-7.9c2.6-0.9,5.5-1,8.1-0.3c8.6,2,15.5,8.6,17.7,17.2c0.8,3.6,1.1,7.4,0.9,11.1c-0.1,11-0.9,22-1.6,33 C266.9,262.9,262.4,260.1,258,258.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M268.9,199.5c0.3,1,0.5,2,0.6,3.1c0.5,7-4.2,12.9-8.8,17.6c-1.8,1.9-4.4,3.1-6,5.1c-1.9,2.2-1.8,5.8-5,6.8 c-2.1,0.5-4.3-0.8-4.8-2.9c-0.2-0.9-0.1-1.8,0.3-2.7c0.6-2.1,1.4-4.1,2.4-5.9c0.9-1.4,2.7-2.2,4.1-3c2.8-1.7,4.8-4.6,5.3-7.9 c0.9-5.9,0-12.6,2.1-18.2c0.3-1,0.9-1.9,1.6-2.6c0.8-0.7,1.9-1,2.9-0.7c1.4,0.5,2,2.2,2.5,3.6C266.9,194.4,268.2,196.9,268.9,199.5 z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M261.2,273.8c0.7,12.6,0.5,25.5-2.9,37.8c-1,3.7-2.7,8.9-6.3,11c-4,2.3-10.3,0.4-14-1.7 c-2.5-1.3-4.7-3.2-6.3-5.5c-2.5-3.7-2.6-8.5-2.3-13c0.8-12,3.7-23.1,6.1-34.8c2.5-12.7,5.5-25.3,8.9-37.9c1.4-5.3,3.3-9.3,7.8-12.7 c3.2-2.4,8.5-5.6,8.8,0.7C261.8,236.3,260.2,255,261.2,273.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.8,209.8c-0.4,0.7-0.7,1.4-0.9,2.1c-0.2,1-0.2,2,0,2.9c0.9,7.3,2.4,14.5,10.3,16.8 c5.5,1.6,11.3,1,16.4-1.7c1.6-0.8,3-1.8,4.2-3.1c1.3-1.2,2-2.9,2.1-4.7c5.3,1.2,10.7-4.2,13.4-8c6.3-8.8,8.4-19.9,7.4-30.5 c-0.2-2.6-0.6-5.4-2.2-7.4c-1.2-1.4-2.6-2.6-4.2-3.5c-7.2-4.6-14.9-4.9-22.7-1.2c-7.1,3.3-12.1,10.4-15.5,17.2 c-1.4,2.9-1.6,6.6-2.8,9.7c-1.3,3.6-3,7.1-5,10.4L210.8,209.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M220.7,172.8c1.5-3.6,3.9-6.7,7-9c5.4-3.8,13.2-3.1,19.3-1.7c3.5,0.8,7,2.3,10.6,2.3c3.3,0,6.7-3.3,9.9-2.2 c1.4,0.5,2.5,1.7,2.8,3.2c0.5,2.4-1,4.7-2.1,6.9c-0.8,1.8-1.8,3.5-2.8,5.1c-1.6,2.1-3.9,3.6-6.5,4c-0.9,0.1-1.7,0-2.6-0.1 c-5.2-0.5-9.5-2-13.5,2.1c-2.7,2.8-4,6.6-6,9.9c-0.4,0.8-1.1,1.5-1.8,2.1c-1.1,0.5-2.3,0.8-3.5,0.9c-5.1,1.2-8.5,9.8-13.9,7.9 c-4.6-1.6-3.6-5.8-1.8-9.1c2.3-4.2,1.9-9.2,2.5-13.9C218.7,178.2,219.5,175.4,220.7,172.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M222,192.6c-1.1,1.6-1.9,3.5-2.2,5.4c-0.4,1.6-0.4,3.4,0,5c0.5,1.7,1.8,3,3.5,3.4c1.3,0.2,2.7-0.3,3.7-1.2 c2.4-2.1,5.2-8.5,4.5-11.8C230.5,188.8,224.3,189.6,222,192.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M226.7,194.4c-1.3,0.5-2.4,1.6-3,2.9c-0.5,1.3-0.9,2.7-1.1,4.1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260.6,195.3c0.1,0.6-0.2,1.3-0.9,1.4c-0.6,0.1-1.3-0.3-1.4-0.9c-0.1-0.6,0.2-1.2,0.9-1.4l0,0 C259.9,194.3,260.5,194.7,260.6,195.3L260.6,195.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M247.5,196.4c0.1,0.6-0.3,1.2-1,1.3l0,0c-0.6,0.1-1.2-0.3-1.4-1c-0.1-0.6,0.3-1.2,1-1.4 C246.8,195.3,247.4,195.7,247.5,196.4C247.5,196.3,247.5,196.3,247.5,196.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.6102,
    y1: -130.1417,
    x2: 205.8202,
    y2: -99.1718,
    gradientTransform: "matrix(1 0 0 -1 42 196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.91
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FFCC00",
      stopOpacity: 0
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M230.5,292.5c-0.5,3.2-0.9,6.5-1.1,9.8c-0.3,4.5-0.2,9.2,2.3,13c1.7,2.3,3.8,4.2,6.3,5.5c3.7,2.1,10,4,14,1.7 c3.5-2,5.2-7.3,6.3-11c1.7-6.2,2.7-12.6,3-19H230.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.5538,
    y1: -74.2957,
    x2: 148.4738,
    y2: -90.5656,
    gradientTransform: "matrix(1 0 0 -1 42 196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.91
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FFCC00",
      stopOpacity: 0
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M194.6,273.1l-5.5-15.6c0.1,0.4-1,2.1-1.2,2.5c-0.4,0.9-0.8,1.8-1.2,2.7c-0.8,1.9-1.7,3.7-2.5,5.5 c-1.5,3.5-3.3,7-5.2,10.4c-1.6-0.5-3.1-1.3-4.4-2.4c-0.5,3.2-1.5,6.1-2.2,9.3c-0.3,1.6-0.6,3.3-0.9,4.9c-0.1,0.8-0.3,1.6-0.5,2.5 c-0.1,0.3-0.2,2.1-0.4,2.3c8.5-5,16.3-11.2,23.1-18.3c0.6-0.5,1-1.2,1.2-2C195,274.3,194.9,273.7,194.6,273.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.5,189c-1.6-0.2-3.2,0.2-4.6,1.1c-0.7,0.4-0.9,1.2-0.6,1.9c0.4,0.7,1.2,0.9,1.9,0.6c0.9-0.6,2-0.9,3.1-0.7 c0.8,0,1.4-0.7,1.4-1.5C262.7,189.7,262.2,189.1,261.5,189L261.5,189z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M250.1,191.2c-2-0.9-4.1-0.5-6.1,0c-1.5,0.4-1.2,2.9,0.4,2.5s3.2-0.9,4.7-0.2S251.6,191.8,250.1,191.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.1411,
    y1: -463.8056,
    x2: 28.4511,
    y2: -477.5055,
    gradientTransform: "matrix(0.9745 -0.2244 -0.2244 -0.9745 97.1036 -227.3265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.91
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FF735F",
      stopOpacity: 0
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M232.5,217.9c-0.1,2.6-0.2,5.2-0.3,7.8c0,1.4-0.1,2.7-0.1,4.1c0,0.2-0.1,0.7-0.1,1.2c1.6-0.3,3.2-0.8,4.7-1.4 c2.2-0.8,4.1-2.4,5.3-4.5c0.4-0.8,0.7-1.7,0.9-2.6C239.3,221.8,235.2,220.4,232.5,217.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M205,323.8c13.5,1.6,28.5,3.4,41.5-0.5c-2-3.1-4.3-6-6.9-8.6s-6-4.3-9.7-4.9c-1.9-0.2-3.9-0.1-5.8,0.2 c-3.4,0.4-7.7,2.2-11.1,1.9c-2.8-0.2-6.5-2.6-9.2-3.7c-18.1-7.2-39.6-16.9-59.5-11.7c-10,2.6-16,11-9.1,20.4 c3.9,5.3,10.1,4.3,16.2,4.4c16.4,0.3,32.9,0.1,49.2,2L205,323.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M245.9,211.8l-1-0.2c0.4-1.8,1.2-3.5,2.3-5c1.1-1.6,2.9-2.6,4.8-2.9c0.6-0.1,1.2,0,1.7,0.1 c1.1,0.4,2,1.3,2.5,2.4l-0.9,0.4c-0.4-0.9-1-1.5-1.9-1.9c-0.4-0.1-0.9-0.2-1.3-0.1c-1.6,0.2-3.1,1.1-4.1,2.5 C246.9,208.5,246.2,210.1,245.9,211.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.4132,
    y1: -107.5284,
    x2: 117.7132,
    y2: -89.8684,
    gradientTransform: "matrix(1 0 0 -1 42 196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.91
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#FF735F",
      stopOpacity: 0
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M171,290.5c-0.1-0.2-0.3-0.5-0.4-0.7c-0.9-1.6-1.8-3.1-2.7-4.7c-1.2,1.3-2.5,2.4-3.9,3.5 c-1.9,1.3-3.6,2.8-5.2,4.5c-1,1-1.9,2.1-2.8,3.1c0.2,0.6,0.5,1.1,0.7,1.7c0.1,0.3,0.2,0.6,0.4,0.9c0.6-0.2,1.3-0.4,1.9-0.6 c3.2-0.9,7.5-2.2,11-1.7c0.2-2,0.9-3.8,1.1-5.8C171,290.7,171,290.6,171,290.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M249.9,215.8c-0.7,0-1.3,0.4-1.7,0.9c-0.1,0.3-0.1,0.6,0.1,0.8c0,0.2,0.2,0.4,0.4,0.4 c0.7,0.1,1.4-0.1,1.8-0.7c0.3-0.3,0.3-0.8,0-1.1C250.3,215.9,250.1,215.8,249.9,215.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M250.9,188.2c-0.7-0.3-1.5-0.5-2.2-0.6c-0.6-0.1-0.6,0.9,0,1c0.7,0.1,1.4,0.3,2,0.5 C251.2,189.4,251.5,188.5,250.9,188.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M257.1,186.8l-1.6,0.5c-0.6,0.2-0.4,1.1,0.3,1l1.6-0.5C258,187.5,257.7,186.6,257.1,186.8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M142.5,47.4h104.7c16.8,0,30.5,13.6,30.5,30.4l0,0v40.8l0,0H142.5c-16.8,0-30.5-13.6-30.5-30.4l0,0V77.8 C112,61,125.6,47.4,142.5,47.4L142.5,47.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M102.7,135.6h75c12.7,0,23,10.3,23,23v30.9l0,0h-98c-12.7,0-23-10.3-23-23v-7.9 C79.7,145.9,90,135.6,102.7,135.6L102.7,135.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M117.8,168.5c-1.4,0.1-2.8-0.4-3.9-1.4c-1-1-1.5-2.5-1.4-3.9c-0.1-1.4,0.4-2.9,1.3-4c0.9-1,2.2-1.5,3.6-1.4 c1.3-0.1,2.5,0.4,3.4,1.2c0.9,0.9,1.3,2.2,1.2,3.4v1.4h-6.6c0,0.7,0.2,1.4,0.7,1.9s1.2,0.7,1.9,0.7c0.6,0,1.2-0.1,1.8-0.2 c0.6-0.1,1.2-0.3,1.7-0.6v2.2c-0.5,0.3-1,0.4-1.6,0.6C119.2,168.4,118.5,168.5,117.8,168.5z M117.4,159.8c-0.5,0-1,0.2-1.4,0.6 c-0.4,0.5-0.6,1-0.6,1.6h4c0-0.6-0.2-1.2-0.5-1.6C118.5,159.9,118,159.7,117.4,159.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M131.9,157.8c0.3,0,0.6,0,0.9,0.1l-0.2,2.6c-0.3-0.1-0.6-0.1-0.8-0.1c-0.8,0-1.5,0.2-2.1,0.7 c-0.5,0.5-0.8,1.2-0.7,1.9v5.2h-2.8V158h2.1l0.4,1.7h0.1c0.3-0.6,0.8-1,1.3-1.4C130.7,158,131.3,157.8,131.9,157.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M142.4,157.8c0.3,0,0.7,0,1,0.1l-0.2,2.6c-0.3-0.1-0.6-0.1-0.8-0.1c-0.8,0-1.5,0.2-2.1,0.7 c-0.5,0.5-0.8,1.2-0.8,1.9v5.2h-2.8V158h2.1l0.4,1.7h0.1c0.3-0.6,0.8-1,1.3-1.4C141.2,158,141.8,157.8,142.4,157.8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M156.5,163.1c0.1,1.4-0.4,2.8-1.3,3.9c-1,1-2.3,1.5-3.7,1.4c-0.9,0-1.8-0.2-2.6-0.6c-0.8-0.4-1.4-1.1-1.8-1.9 c-0.4-0.9-0.6-1.9-0.6-2.8c-0.1-1.4,0.4-2.8,1.3-3.9c1-1,2.3-1.5,3.7-1.4c0.9,0,1.8,0.2,2.6,0.6c0.8,0.4,1.4,1.1,1.7,1.9 C156.3,161.2,156.5,162.1,156.5,163.1z M149.4,163.1c-0.1,0.8,0.1,1.6,0.5,2.3c0.4,0.5,1,0.8,1.6,0.8c0.6,0.1,1.3-0.2,1.6-0.8 c0.4-0.7,0.5-1.5,0.5-2.3c0.1-0.8-0.1-1.6-0.5-2.3c-0.4-0.5-1-0.8-1.6-0.8c-0.6-0.1-1.3,0.2-1.6,0.8 C149.5,161.5,149.3,162.3,149.4,163.1L149.4,163.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M166.5,157.8c0.3,0,0.6,0,0.9,0.1l-0.2,2.6c-0.3-0.1-0.6-0.1-0.8-0.1c-0.8,0-1.5,0.2-2.1,0.7 c-0.5,0.5-0.8,1.2-0.8,1.9v5.2h-2.8V158h2.1l0.4,1.7h0.1c0.3-0.6,0.8-1,1.3-1.4C165.2,158,165.9,157.8,166.5,157.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M144.8,310.9c-1.3,0-2.6-0.1-3.8-0.4l0.4-2.1c4.4,0.9,11.5,0,13.5-4.2c0.6-1.3,0.6-2.8,0-4.1 c-0.6-1.3-1.8-2.2-3.1-2.6c-2.7-0.8-6.2,0.1-8.5,1.4l-1.1-1.9c2.5-1.4,6.7-2.7,10.2-1.6c1.9,0.6,3.5,1.9,4.4,3.7 c0.9,1.9,0.9,4.1,0,6C154.8,309.4,149.4,310.9,144.8,310.9z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M113.5,290.2h34.8l0,0v14.2c0,7.6-6.1,13.7-13.7,13.7l0,0h-7.4c-7.6,0-13.7-6.1-13.7-13.7l0,0L113.5,290.2 L113.5,290.2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M158,320.2h-53.6c-0.9,0-1.6-0.7-1.6-1.6l0,0c0-0.9,0.7-1.6,1.6-1.6l0,0H158c0.9,0,1.6,0.7,1.6,1.6l0,0l0,0 C159.6,319.5,158.9,320.2,158,320.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_6_",
    d: "M360.1,284.3c0.3-1.9,0.9-3.6,2.5-4.5c2.2-1.3,5-0.2,7.6-0.7c7.1-1.3,7-11.2,6.9-16.6 c-0.1-3.5-0.2-6.9-0.5-10.4c0-0.9-0.2-1.8-0.6-2.6c-1-1.4-2.8-1.9-4.4-1.4c-3.1,0.9-4.8,4.2-5.4,7.4s-0.3,6.5-1.1,9.6 c-0.1,0.6-0.4,1.2-0.7,1.7c-0.4,0.6-0.9,1-1.5,1.3c-0.9,0.5-2,0.5-2.9,0c-1-0.6-0.8-1.4-0.8-2.4c0-1.2-0.1-2.3-0.3-3.5 c-0.3-2.6-0.6-5.2-0.8-7.8c-0.5-5.1-0.9-10.2-1.4-15.4c-0.1-2.4-0.7-4.7-1.7-6.9c-5.1-9.1-12.8-1.1-13.5,5.5 c-1.6,15.1,6.2,29.3,5.6,44.3c0,0.6-0.1,1.3-0.4,1.9c-1.2,2.4-5,2-6.7,0.6c-2.7-2.1-1.8-6.8-1.8-9.5c0-2.3-0.7-4.8-2.9-5.9 c-2.5-1.2-5.7,0.2-7.1,2.5c-1.8,2.9-1.6,7.8-1.4,11c0.1,2.3,0.8,4.6,2.1,6.6c1.4,2.1,3.7,3.4,6.1,3.6c1.5,0.1,3.1-0.2,4.2,0.7 c1.4,1.1,0.9,3,0.9,4.6c0.1,3.2,2.9,6,6.1,7.4s6.9,1.6,10.4,1.8c3-4.8,3.2-10.4,3.4-15.8C359.9,289,359.9,286.7,360.1,284.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M360.1,284.3c0.3-1.9,0.9-3.6,2.5-4.5c2.2-1.3,5-0.2,7.6-0.7c7.1-1.3,7-11.2,6.9-16.6 c-0.1-3.5-0.2-6.9-0.5-10.4c0-0.9-0.2-1.8-0.6-2.6c-1-1.4-2.8-1.9-4.4-1.4c-3.1,0.9-4.8,4.2-5.4,7.4s-0.3,6.5-1.1,9.6 c-0.1,0.6-0.4,1.2-0.7,1.7c-0.4,0.6-0.9,1-1.5,1.3c-0.9,0.5-2,0.5-2.9,0c-1-0.6-0.8-1.4-0.8-2.4c0-1.2-0.1-2.3-0.3-3.5 c-0.3-2.6-0.6-5.2-0.8-7.8c-0.5-5.1-0.9-10.2-1.4-15.4c-0.1-2.4-0.7-4.7-1.7-6.9c-5.1-9.1-12.8-1.1-13.5,5.5 c-1.6,15.1,6.2,29.3,5.6,44.3c0,0.6-0.1,1.3-0.4,1.9c-1.2,2.4-5,2-6.7,0.6c-2.7-2.1-1.8-6.8-1.8-9.5c0-2.3-0.7-4.8-2.9-5.9 c-2.5-1.2-5.7,0.2-7.1,2.5c-1.8,2.9-1.6,7.8-1.4,11c0.1,2.3,0.8,4.6,2.1,6.6c1.4,2.1,3.7,3.4,6.1,3.6c1.5,0.1,3.1-0.2,4.2,0.7 c1.4,1.1,0.9,3,0.9,4.6c0.1,3.2,2.9,6,6.1,7.4s6.9,1.6,10.4,1.8c3-4.8,3.2-10.4,3.4-15.8C359.9,289,359.9,286.7,360.1,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M350.6,228.5c3.6,25,6.7,50.5,2.3,75.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M347.1,228.4c-1,4.7-2,9.4-2,14.1c0,9.1,3.9,17.7,5.4,26.7c1.7,10,0.4,20.2-0.8,30.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M354.9,272.6c4.4-0.6,9.6-1.2,12.3-4.7c0.4-0.5,0.7-1,0.9-1.6c0.7-2.4,0.4-5,0.4-7.5c0-2.4,0-6.4,0-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M351,289.2c-3.9,0.6-8.2,1.2-11.6-0.7c-2-1.2-3.5-3.1-4.2-5.3c-0.7-2.1-1-4.4-0.9-6.6 c0-2.4,0.2-4.8,0.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M355,276.6c5-0.7,9.8-2,14.5-3.8c1-0.3,1.9-0.8,2.7-1.5c0.7-0.8,1.2-1.8,1.4-2.8c0.7-2.3,1-17.8,0.2-21.5 "
  })))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "336.4,298.8 365.8,298.2 362.8,320 340.4,320  "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M205.2,315.6H329c1.4,0,2.5,1.1,2.5,2.5v0.9c0,1.4-1.1,2.5-2.5,2.5H205.2c-1.4,0-2.5-1.1-2.5-2.5v-0.9 C202.7,316.7,203.8,315.6,205.2,315.6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M331.9,321.4h-110l9.6-63.2c0.3-2.2,2.2-3.8,4.4-3.8h101.3c2.4,0,4.3,2,4.2,4.3c0,0.2,0,0.4-0.1,0.7 L331.9,321.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 286.9,
    cy: 283.4,
    r: 5.3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.3,249.5c-0.7-2.9-1-5.9-1-8.8s0.5-5,2.4-7.2c1.4-1.7,3-3.2,4.7-4.6c4.4-3.7,6-9.8,4-15.1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.6,241c-0.6-2.5,0.8-5,2.5-6.9s3.9-3.4,5.4-5.4c3.2-4.4,3.1-8.5,2.5-16.7c-0.4-5.8-0.3-12.3,3.8-16.3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M48.9,319.3h319.4c1.7,0,3,1.3,3,3v1c0,1.7-1.3,3-3,3H48.9c-1.7,0-3-1.3-3-3v-1 C45.9,320.6,47.2,319.3,48.9,319.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M401,137.7c2.5,15.7,3.5,32.5-3.7,46.7c-4,7.9-10.3,14.4-13.9,22.6c-3.8,8.7-5.2,17.7-6.1,27.1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M77.3,111.5c-10,12.1-24.8,18.9-36.8,29c-19.6,16.7-30.7,41.2-30.4,66.9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M296.3,11.3c16.5,5.3,30,17.3,37.2,33"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M68.7,345.8c22.3,19.4,50.3,31,79.8,33"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M288.1,351.6c5.4-2.4,10.6-5.1,15.7-8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M215.1,366.3c21.3-0.9,39.7-2,62.7-11"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 146.54 104.29)",
    className: "st17 st24 st25"
  }, "500"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.d508258f709520f00e23f43ca802434b.svg";
export { ForwardRef as ReactComponent };